import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/random-team-stacking/actions';

class TeamChecking extends Component {
    onChange(isChecked) {
        this.props.dispatch(Action.set('TeamIsChecked', this.props.team, isChecked));
    }

    render() {
        const {team, stacking} = this.props;

        const isChecked = stacking.isTeamChecked(team);

        return (
            <label className="stack-chk">
                <input
                    value="1"
                    type="checkbox"
                    onChange={(e) => ::this.onChange(e.target.checked)}
                    checked={isChecked}
                    className="form-control"
                />
                {team}
            </label>
        );
    }
}

function mapStatesToProps(state) {
    const {randomTeamStacking} = state;
    return {
        stacking: randomTeamStacking,
    };
}

export default connect(mapStatesToProps)(TeamChecking);
